var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_917_5298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72365 10.4771H4.02074C3.58405 10.4771 3.23004 10.8311 3.23004 11.2678C3.23004 11.7044 3.58405 12.0584 4.02074 12.0584H8.72365C9.16034 12.0584 9.51434 11.7044 9.51434 11.2678C9.51434 10.8311 9.16034 10.4771 8.72365 10.4771Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1799 14.4077H4.02074C3.58405 14.4077 3.23004 14.7617 3.23004 15.1984C3.23004 15.6351 3.58405 15.9891 4.02074 15.9891H7.1799C7.61659 15.9891 7.9706 15.6351 7.9706 15.1984C7.9706 14.7617 7.61659 14.4077 7.1799 14.4077Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6153 11.7741V1.58718C20.6153 0.715797 19.9063 0.00683594 19.0349 0.00683594C18.5752 0.00683594 3.41708 0.00683594 1.58034 0.00683594C0.709014 0.00683594 0 0.71585 0 1.58718V19.0418C0 19.9137 0.709014 20.6227 1.58034 20.6227H11.7836C12.3998 24.2346 15.5521 26.9931 19.337 26.9931C23.5625 26.9931 27 23.5557 27 19.3301C27 15.5405 24.2347 12.3845 20.6153 11.7741ZM7.70676 1.58823H12.9085V4.44586L10.6023 3.51968C10.4188 3.44591 10.208 3.44169 10.0129 3.51968L7.70671 4.44586V1.58823H7.70676ZM11.6803 19.0413L1.58145 19.0418L1.5804 1.58823L6.12536 1.58771V5.61556C6.12536 6.17607 6.69331 6.55655 7.21074 6.34936L10.3077 5.1053L13.4046 6.34936C13.9295 6.55813 14.49 6.16974 14.49 5.61556V1.58771L19.0339 1.58718L19.0349 11.6739C15.0451 11.8289 11.8284 15.0497 11.6803 19.0413ZM19.337 25.4117C16.4272 25.4117 13.9882 23.3575 13.3946 20.6227C12.4543 16.3291 16.2954 12.4509 20.6153 13.3845C23.357 13.9728 25.4186 16.4151 25.4186 19.3301C25.4186 22.6838 22.6901 25.4117 19.337 25.4117Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2721 17.3698C20.4228 18.0119 21.0057 17.5711 18.3755 19.5606C17.8663 18.9109 18.0541 19.1504 17.5479 18.5048C17.0682 17.8939 16.0894 18.2724 16.1362 19.0414C16.1551 19.3662 16.2 19.3484 17.6101 21.1484C17.8763 21.4874 18.3647 21.5509 18.7097 21.2912L22.2257 18.6313C22.5742 18.3677 22.6427 17.8717 22.3797 17.5238C22.116 17.1754 21.62 17.1068 21.2721 17.3698Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_917_5298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.c342a0ac6e004a20ed4cef1071cccbc5.svg";
export { ForwardRef as ReactComponent };